import { styled } from '@mui/material/styles';
import MUIButton from '@mui/material/Button';

const Button = styled(MUIButton)({
  textTransform: 'none',
}) as typeof MUIButton;

export default Button;
